<script setup>
import CustomDropdown from "@/components/CustomDropdown.vue";
// import { ref, computed, reactive, defineExpose, defineEmits } from "vue";
import { ref, computed, reactive, defineExpose } from "vue";
import { usePushesStore } from "@/store/pushes";

// const notificationsStore = useNotificationsStore();
const pushesStore = usePushesStore();
// const emit = defineEmits(["showModal", "clearFilter"]);
const form = ref({
  customer: "",
  count: 100,
  type: "all",
});
// const showTooltip = ref(false);
const showCountTooltip = ref(false);
const customerDropdown = ref(null);
const countDropdown = ref(null);
const typeDropdown = ref(null);
const buttonStates = reactive({
  1: { text: "", selectedValue: "" },
});

// const clearButtonValue = (buttonId) => {
//   buttonStates[buttonId].text = "";
//   buttonStates[buttonId].selectedValue = "";
//
//   switch (buttonId) {
//     case 1:
//       // ordersStore.setSelectedCustomer("");
//       break;
//   }
//
//   emit("clearFilter", buttonId);
// };

// const filterButtons = computed(() => [
//   {
//     id: 1,
//     text: buttonStates[1].text || "Клиенты",
//     originalText: "Клиенты",
//     selectedValue: buttonStates[1].selectedValue,
//   },
// ]);

// const showModal = (button) => {
//   emit("showModal", {
//     title: button.originalText,
//     buttonId: button.id,
//     currentValue: button.selectedValue,
//   });
// };

const updateButtonText = (buttonId, newText) => {
  if (newText) {
    buttonStates[buttonId].text = newText;
    buttonStates[buttonId].selectedValue = newText;
  } else {
    buttonStates[buttonId].text = "";
    buttonStates[buttonId].selectedValue = "";
  }
  switch (buttonId) {
    case 1: // Покупатели
      // ordersStore.setSelectedCustomer(newText);
      break;
  }
};
const openDropdown = ref(null);
// onMounted(async () => {
//     // await pushesStore.fetchItemsList();
//     // form.value.customer = pushesStore.selectedCustomer;
//     // form.value.type = pushesStore.selectedType;
// });

// const handleCustomerChange = (newCustomer) => {
//   form.value.customer = newCustomer;
//   // Update the selected customer in the appropriate store
//   // pushesStore.setSelectedCustomer(newCustomer);
// };
const handleCountChange = (newCount) => {
  form.value.count = newCount;
  pushesStore.setCount(newCount);
};
const handleTypeChange = (newType) => {
  form.value.type = newType;
  pushesStore.setSelectedType(newType);
};

const handleDropdownOpen = (openedDropdown) => {
  openDropdown.value = openedDropdown;
  const dropdownRefs = {
    customer: customerDropdown,
    count: countDropdown,
    type: typeDropdown,
  };

  // Close all other dropdowns
  Object.entries(dropdownRefs).forEach(([name, ref]) => {
    if (
      name !== openedDropdown &&
      ref.value &&
      typeof ref.value.closeDropdown === "function"
    ) {
      ref.value.closeDropdown();
    }
  });
};
const handleDropdownClose = () => {
  openDropdown.value = null;
};

// const shouldShowCustomerTooltip = computed(() => {
//   return showTooltip.value && openDropdown.value !== "customer";
// });

const shouldShowCountTooltip = computed(() => {
  return showCountTooltip.value && openDropdown.value !== "count";
});

const countsOptions = [
  // { value: 'all', label: "Все" },
  { value: 50, label: "50" },
  { value: 100, label: "100" },
  { value: 500, label: "500" },
  { value: 1000, label: "1000" },
];

const typeOptions = [
  { value: "all", label: "Все" },
  { value: "pushLoadingDelay", label: "Задержка до погрузки" },
  { value: "pushUnloadingStay", label: "Задержка после доставки" },
  { value: "pushDrivingDelay", label: "Остановка в пути" },
  // { value: "pushLostConnection", label: "А/м не на связи" },
  // { value: "pushRegainedConnection", label: "А/м на связи" },
  { value: "missingDispatcherTruck", label: "А/м нет в Портале" },
];

// const refresh = () => {
//   console.log("Refreshing notifications...");
//   // pushesStore.applyCount();
// };

defineExpose({
  updateButtonText,
});
</script>

<template>
  <div class="notifications-filters">
    <div class="notifications-filters_wrap">
<!--      <div class="notifications-tips">-->
<!--        <div-->
<!--          v-for="button in filterButtons"-->
<!--          :key="button.id"-->
<!--          class="notifications-filters_button"-->
<!--          @click="showModal(button)"-->
<!--        >-->
<!--          <span class="button-text">{{ button.text }}</span>-->
<!--          <span-->
<!--            v-if="button.selectedValue"-->
<!--            class="clear-button"-->
<!--            @click.stop="clearButtonValue(button.id)"-->
<!--          >-->
<!--            <svg-->
<!--              width="18"-->
<!--              height="18"-->
<!--              viewBox="0 0 24 24"-->
<!--              fill="none"-->
<!--              xmlns="http://www.w3.org/2000/svg"-->
<!--            >-->
<!--              <path-->
<!--                d="M18 6L6 18"-->
<!--                stroke="currentColor"-->
<!--                stroke-width="2"-->
<!--                stroke-linecap="round"-->
<!--                stroke-linejoin="round"-->
<!--              />-->
<!--              <path-->
<!--                d="M6 6L18 18"-->
<!--                stroke="currentColor"-->
<!--                stroke-width="2"-->
<!--                stroke-linecap="round"-->
<!--                stroke-linejoin="round"-->
<!--              />-->
<!--            </svg>-->
<!--          </span>-->
<!--        </div>-->
<!--        <div class="custom-tooltip" v-show="shouldShowCustomerTooltip">-->
<!--          <div class="tooltip-content">Запрос уведомлений по покупателю</div>-->
<!--        </div>-->
<!--      </div>-->
      <custom-dropdown
        v-model="form.type"
        :options="typeOptions"
        class="types-dropdown"
        width="100%"
        height="35px"
        ref="typeDropdown"
        arrow-height="5"
        arrow-width="8"
        label="Тип"
        @update:modelValue="handleTypeChange"
        @open="handleDropdownOpen('type')"
      />
    </div>

    <div class="notifications-filters_wrapper">
<!--      <p>Показать по</p>-->
      <div class="notifications-tips">
        <custom-dropdown
          v-model="form.count"
          :options="countsOptions"
          width="100%"
          height="35px"
          arrow-height="5"
          arrow-width="8"
          label="Показать последние"
          ref="countDropdown"
          @update:modelValue="handleCountChange"
          @mouseenter="showCountTooltip = true"
          @mouseleave="showCountTooltip = false"
          @open="handleDropdownOpen('count')"
          @close="handleDropdownClose"
        />
        <div class="custom-tooltip" v-show="shouldShowCountTooltip">
          <div class="tooltip-content">
            Кол-во запрашиваемых последних уведомлений
          </div>
        </div>
      </div>

<!--      <div @click="refresh" class="notifications-filters_btn">-->
<!--        <svg-->
<!--          width="21"-->
<!--          height="21"-->
<!--          viewBox="0 0 21 21"-->
<!--          fill="none"-->
<!--          xmlns="http://www.w3.org/2000/svg"-->
<!--        >-->
<!--          <g clip-path="url(#clip0_656_4352)">-->
<!--            <path-->
<!--              d="M10.5 2.16674C11.6054 2.17037 12.6992 2.39319 13.7179 2.82231C14.7366 3.25143 15.6602 3.87834 16.435 4.66674H13V6.33341H17.2858C17.6961 6.33297 18.0895 6.16978 18.3796 5.87967C18.6697 5.58955 18.8329 5.19619 18.8333 4.78591V0.500073H17.1667V3.06507C15.7312 1.77245 13.9517 0.923953 12.0437 0.622414C10.1357 0.320875 8.1812 0.579245 6.4171 1.36621C4.65301 2.15317 3.15505 3.43494 2.1048 5.05615C1.05455 6.67736 0.497097 8.56841 0.500011 10.5001H2.16668C2.1691 8.29068 3.04786 6.17247 4.61013 4.6102C6.17241 3.04792 8.29062 2.16917 10.5 2.16674Z"-->
<!--              fill="white"-->
<!--            />-->
<!--            <path-->
<!--              d="M18.8337 10.5C18.8361 12.1544 18.3452 13.7721 17.4239 15.1462C16.5026 16.5204 15.1926 17.5888 13.6611 18.2149C12.1297 18.8409 10.4465 18.9963 8.8263 18.6612C7.20615 18.3261 5.72267 17.5156 4.56533 16.3333H8.00033V14.6667H3.71449C3.30421 14.6671 2.91085 14.8303 2.62073 15.1204C2.33061 15.4105 2.16743 15.8039 2.16699 16.2142V20.5H3.83366V17.935C5.2691 19.2276 7.04866 20.0761 8.95665 20.3777C10.8646 20.6792 12.8191 20.4208 14.5832 19.6339C16.3473 18.8469 17.8453 17.5651 18.8955 15.9439C19.9458 14.3227 20.5032 12.4317 20.5003 10.5H18.8337Z"-->
<!--              fill="white"-->
<!--            />-->
<!--          </g>-->
<!--          <defs>-->
<!--            <clipPath id="clip0_656_4352">-->
<!--              <rect-->
<!--                width="20"-->
<!--                height="20"-->
<!--                fill="white"-->
<!--                transform="translate(0.5 0.5)"-->
<!--              />-->
<!--            </clipPath>-->
<!--          </defs>-->
<!--        </svg>-->
<!--      </div>-->
    </div>
  </div>
</template>

<style scoped lang="scss">
.form-check-input {
  width: 20px;
  min-width: 20px;
  height: 20px;
  margin-right: 8px;
  appearance: none;
  background-image: url("@/assets/images/system/ok.svg");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  border-radius: 4px;
  margin-top: 0px;
  border: 1px solid #dee2e6;
}

.form-check-label {
  color: #4d5460;
  font-size: 14px;
}

.notifications-tips {
  position: relative;
  display: block;
  cursor: pointer;
  width: 100%;
}

.form-check-input:checked {
  background-color: #2c5697;
  border-color: #2c5697;
}
.button-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
  max-width: calc(100% - 20px);
}
.clear-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  color: #4d5460;
  cursor: pointer;
  flex-shrink: 0;
}
.custom-tooltip {
  position: absolute;
  left: 0;
  right: 0; /* Change from 'auto' to '0' to ensure full width */
  bottom: 100%;
  transform: none;
  background-color: #000000;
  color: #ffffff;
  padding: 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 400;
  font-family: Open Sans, sans-serif;
  z-index: 10;
  width: 100%;
  margin-top: 5px;
  white-space: pre-line;
  word-wrap: break-word;
  line-height: 1;
  text-align: center;
  box-sizing: border-box;

  &:after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #000000;
    border-bottom: none;
  }
}

.tooltip-content {
  text-align: center;
  width: 100%;
}

.notifications-filters {
  margin-bottom: 16px;
  &_wrapper {
    display: flex;
    margin-top: 8px;
    margin-bottom: 8px;
    align-items: center;
    gap: 8px;
    p {
      font-size: 14px;
      color: #4d5460;
      margin-bottom: 0;
    }
  }
  &_wrap {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  &_active {
    display: flex;
    align-items: center;
    margin-top: 8px;
  }
  &_btn {
    background-color: #005291;
    border-radius: 6px;
    color: white;
    height: 35px;
    width: 35px;
    padding: 7px;
    cursor: pointer;
    svg {
      fill: white;
      display: flex;
    }
  }
  &_button {
    border-radius: 6px;
    border: 1px solid #dde5ed;
    padding: 8px 12px;
    cursor: pointer;
    height: 35px;
    width: 156px;
    background-color: #fff;
    color: #4d5460;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
